import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import logo from '../assets/logo.png';

const companyLinks = [
  { label: 'About Us',           to: '/about' },
  { label: 'Speciality Care',    to: '/speciality-services' },
  { label: 'Webinars',           to: '/webinars' },
  { label: 'Insights',           to: '/blog' },
  { label: 'Contact Us',         to: '/contact' },
];

const Footer = () => {
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <footer className="bg-gradient-to-br from-[#1e3a8a] to-[#2563eb] text-white pt-16 pb-8 relative overflow-hidden">
      {/* Decorative watermark */}
      <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 text-center text-[#ffffff]/5 text-[6rem] sm:text-[8rem] lg:text-[10rem] font-black select-none pointer-events-none leading-none tracking-tighter">
        Globe Medical
      </div>

      <div className="mx-auto max-w-7xl px-3 sm:px-4 md:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-12">
          {/* Logo and Social */}
          <div>
            <div className="flex items-center mb-6">
              <img src={logo} alt="Globe Medical" className="h-12 w-auto object-contain brightness-0 invert" width="160" height="48" />
            </div>
            <div className="flex space-x-4">
              <a href="#" aria-label="Globe Medical on Facebook" className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-[#22d3ee] transition-all duration-300">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" aria-label="Globe Medical on Twitter" className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-[#22d3ee] transition-all duration-300">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" aria-label="Globe Medical on Instagram" className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-[#22d3ee] transition-all duration-300">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" aria-label="Globe Medical on LinkedIn" className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-[#22d3ee] transition-all duration-300">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="text-white/80 hover:text-[#22d3ee] transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Contact</h3>
            <div className="space-y-3">
              <div>
                <p className="text-sm font-semibold mb-1">Mobile</p>
                <p className="text-white/80">+44 7814 258693</p>
              </div>
              <div>
                <p className="text-sm font-semibold mb-1">Our Address</p>
                <p className="text-white/80 leading-relaxed">
                  18, Century House,<br />
                  Forty Avenue, Wembley,<br />
                  HA9 8RS, United Kingdom
                </p>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Subscribe To Newsletters</h3>
            <p className="text-white/80 text-sm mb-4 leading-relaxed">
              Expert insights, health tips, and important updates to help you breathe easier, hear clearly
            </p>
            <form onSubmit={handleNewsletterSubmit} className="relative">
              <Input
                type="email"
                placeholder="Enter Email Address"
                className="bg-white/10 backdrop-blur-sm border-white/20 text-white placeholder:text-white/60 pr-12"
                required
              />
              <Button
                type="submit"
                size="icon"
                className="absolute right-1 top-1 bg-[#22d3ee] hover:bg-[#22d3ee]/90 rounded-full"
              >
                <ArrowRight className="h-4 w-4" />
              </Button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-white/80 text-xs sm:text-sm">
            Copyright © 2025 Globe Medical. All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;